export default function (context) {
    let setting = context.rootState.settings.invoices;
    let items = context.state.list.items;
    if(items.length){
        if(setting.search){
            context.commit('list/clean');
            context.dispatch('search');
            return;
        }
        return;
    }
    context.commit('list/clean');
    let filter;
    if (setting.defaultFilter) {
        filter = setting.filters.filter(i => {
            return i.id === setting.defaultFilter;
        })[0];
    }else{
        filter = setting.filters[0];
    }
    if (filter) {
        context.dispatch('form/filter', filter);
    }








}